import { ref, onMounted } from 'vue';
export default {
  name: 'PopUp',
  props: {
    // eslint-disable-next-line vue/require-default-prop
    config: {
      type: Object,
      clear: Function
    }
  },
  setup(props) {
    const visible = ref(true);
    const cancel = () => {
      props.config.cancel();
      visible.value = false;
      props.config.clear();
    };
    const confirm = () => {
      props.config.confirm();
      visible.value = false;
      props.config.clear();
    };
    return {
      visible,
      cancel,
      confirm
    };
  }
};